import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { mainurl } from '../../MainUrl';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/layout/Page';
import Title from '../../component/layout/Title';
import { Row, Col, Card, CardBody, Spinner } from 'reactstrap';
import { notification } from '../../component/hocs/notification';
import DataTable from 'react-data-table-component'; // Ensure DataTable is imported

const ViewMachine = () => {
  const [tableData, setTableData] = useState([]); // State to hold the table data
  const [loading, setLoading] = useState(false); // Loading state

  // Fetch all machines (view_machine)
  const get_list_handler = () => {
    setLoading(true);
    axios
      .get(mainurl + 'view_machine') // Fetch data from the API
      .then((response) => {
        console.log('View Machine API Response:', response.data); // Log API response
        const list = response.data.data.map((row, index) => ({
          sl: index + 1,
          Product_Name: row?.product_name ?? '', // If product_name is null, default to empty string
          Machine_No: row?.machine_no ?? '', // Default empty string for machine_no
          Stock_In: row?.stock_in ?? '0.00', // Default 0 if stock_in is null
          Transaction_Date: row?.transaction_date ?? 'N/A', // Default 'N/A' if transaction_date is null
          UOM: row?.uom ?? 'N/A', // Default 'N/A' for UOM if null
          ...row, // Spread rest of the machine data (optional)
        }));
        setTableData(list); // Set the data for the table
        setLoading(false); // Set loading to false once the data is fetched
      })
      .catch((error) => {
        console.error('Error in View Machine API:', error); // Log any errors
        setLoading(false); // Set loading to false in case of error
        notification('error', 'Failed to fetch machine data'); // Show an error notification
      });
  };

  // Fetch machine data when the component is mounted
  useEffect(() => {
    get_list_handler(); // Call the function to fetch the machine list
  }, []);

  // Custom table styling with light blue background for header and black text
  const custTableStyles = {
    rows: {
      highlightOnHover: true,
    },
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#FF0000', // Set header background color to light blue (#ADD8E6)
        color: 'white', // Set header text color to black
      },
    },
    cells: {
      style: {
        padding: '10px', // Add padding to table cells
      },
    },
  };

  return (
    <div>
      <Header />
      <Page>
        <Row className="mb-3">
          <Col xs={12} className="mb-1">
            <Title pageTitle="View Machine" />
          </Col>

          <Col xs={12}>
            <Card color="primary" outline>
              <CardBody>
                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" /> {/* Show spinner while loading */}
                  </div>
                ) : (
                  <DataTable
                    customStyles={custTableStyles} // Apply custom styles
                    columns={[
                      { name: 'Sl No', selector: (row) => row.sl, width: '50px' },
                      { name: 'Product Name', selector: (row) => row.Product_Name, wrap: true },
                      { name: 'Machine No', selector: (row) => row.Machine_No, wrap: true },
                      { name: 'Stock In', selector: (row) => row.Stock_In, wrap: true },
                      { name: 'Transaction Date', selector: (row) => row.Transaction_Date, wrap: true },
                      { name: 'UOM', selector: (row) => row.UOM, wrap: true }, // Corrected UOM selector
                    ]}
                    data={tableData} // Use tableData instead of filterData
                    keyField="sl"
                    pagination
                    progressPending={loading}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
      <Footer />
    </div>
  );
};

export default ViewMachine;
